<template>
  <div class="ds-page" v-if="!$store.getters.isForbidden">
    <div class="page-header d-print-none">
      <div class="row align-items-center">
        <div class="col">
          <div class="page-pretitle">Categories</div>
          <h2 class="page-title">{{ $route.name }}</h2>
          <p class="page-subtitle">
            Configure classification groups, campaign categorization, and structural lifecycle logs.
          </p>
        </div>
      </div>
    </div>

    <div class="ds-card">
      <div class="cc-page__table-head">
        <div>
          <div class="cc-page__table-title">Filters</div>
          <div class="cc-page__table-subtitle">
            Filter categories by dynamic keywords and relational properties.
          </div>
        </div>
      </div>

      <div class="cc-page__filter-grid rf-page__filter-layout-category">
        <div class="ds-field">
          <label class="ds-field__label">Search Keyword</label>
          <el-input
            v-model.trim="search_category.search_value"
            size="small"
            placeholder="Input search keyword"
            clearable
            @clear="searchHandler"
            @keyup.enter.native="searchHandler"
          />
        </div>

        <div class="ds-field">
          <label class="ds-field__label">Search By</label>
          <el-select size="small" v-model="search_category.search" class="w-100">
            <el-option
              v-for="(item, index) in search_options"
              :key="index"
              :value="item.value"
              :label="item.text"
            />
          </el-select>
        </div>

        <div class="cc-page__filter-actions rf-page__filter-actions">
          <button class="ds-btn ds-btn--primary ds-btn--sm" @click="searchHandler">
            <font-awesome-icon icon="search" /> Search
          </button>
        </div>
      </div>
    </div>

    <div class="ds-card">
      <div class="ds-table-wrap">
        <table class="ds-table">
          <thead>
            <tr>
              <th width="15%">ID</th>
              <th width="45%">Category Name</th>
              <th width="20%">Created At</th>
              <th width="20%">Updated At</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in list" :key="i">
              <td>
                <span class="cc-page__identity-sub">#{{ item?.id }}</span>
              </td>
              <td>
                <div class="cc-page__identity">
                  <span class="cc-page__identity-name">{{ item?.name || '—' }}</span>
                </div>
              </td>
              <td>
                <span class="text-muted" style="font-size: 13px">{{
                  item?.created_at_str || '—'
                }}</span>
              </td>
              <td>
                <span class="text-muted" style="font-size: 13px">{{
                  item?.updated_at_str || '—'
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <el-empty
          v-if="total_rows === 0 || !list.length"
          description="No categories found"
          :image="emptyStateImage"
          class="ds-empty"
        />
      </div>

      <pagination
        :page="page"
        :per_page="per_page"
        :list="list"
        :total_rows="total_rows"
        @pageChange="pageChangeHandler"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { upperFirst } from 'lodash';
import emptyStateImage from '@/assets/images/empty-state.png';
import Pagination from '../components/Pagination.vue';
// import { EDIT_CATEGORY, CREATE_CATEGORY, GET_CATEGORIES } from '../../store/modules/app_user';
import { GET_CATEGORIES } from '../../store/modules/app_user';
import popupErrorMessages from '@/library/popup-error-messages';
export default {
  components: { Pagination },
  name: 'Referral',
  metaInfo: {
    title: 'Referral Categories',
  },
  data() {
    return {
      category: {
        name: '',
        user_id: null,
      },
      user_id: null,
      search_options: [{ value: 'name', text: 'Name' }],
      search_category: {
        search: 'name',
        search_value: '',
      },
      emptyStateImage,
      per_page: 20,
      total_rows: 0,
      page: 1,
      list: [],
      isLoading: true,
      loader: null,
      datePickerOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), 'days'),
      },
    };
  },
  async created() {
    // CATEGORY
    this.category.user_id = localStorage.getItem('user_id');
  },
  async mounted() {
    await this.getList();
  },
  computed: {
    showingFrom() {
      return this.total_rows ? (this.page - 1) * this.per_page + 1 : 0;
    },
    showingUntil() {
      if (this.total_rows) {
        if (this.list.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },
  methods: {
    async getList() {
      await this.$store
        .dispatch(GET_CATEGORIES, {
          search: this.search_category.search,
          search_value: this.search_category.search_value,
        })
        .catch(() => {});
      const { rows, count } = this.$store.getters.get_categories;
      this.total_rows = count || 0;
      this.list = rows;
    },
    pageChangeHandler(page) {
      this.page = page;
      this.getList();
    },
    searchHandler() {
      this.search_category.search = this.search_category.search;
      this.search_category.search_value = this.search_category.search_value;
      this.getList();
    },
    // CREATE CATEGORY
    async doCreateCategory() {
      await this.$store
        .dispatch(CREATE_CATEGORY, this.category)
        .then(() => {
          this.$message({
            title: 'Success',
            type: 'success',
            message: 'Category created',
          });
        })
        .catch((err) => {
          popupErrorMessages(err.response.data);
        });
    },
    // UPDATE
    async doUpdateData() {
      this.$confirm(
        'You will update this category. Make sure you have input data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              await this.$store
                .dispatch(EDIT_CATEGORY, this.category)
                .then(() => {
                  this.$message({
                    title: 'Success',
                    type: 'success',
                    message: 'Category updated',
                  });
                  this.showModalCreate = false;
                  this.getList();
                })
                .catch((err) => {
                  popupErrorMessages(err.response.data);
                });
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
  },
};
</script>
<style>
.el-range-separator {
  width: 10% !important;
}

.child1-sticky {
  position: sticky;
  right: 0px;
  width: 40px;
  background: #fff;
}

.child2-sticky {
  position: sticky;
  right: 69px;
  width: 255px;
  background: #fff;
}
/* del */
.table-container {
  width: 100%;
  overflow-x: auto;
}

.table-responsive {
  overflow-x: auto;
}

.buttonload {
  background-color: #006ea5; /* Green background */
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 12px 16px; /* Some padding */
  font-size: 16px; /* Set a font size */
}

.dialog-footer button:first-child {
  margin-right: 10px;
}

.rf-page__filter-layout-category {
  grid-template-columns: 2fr 1fr auto !important;
}

.rf-page__filter-actions {
  align-self: end;
}

@media (max-width: 900px) {
  .rf-page__filter-layout-category {
    grid-template-columns: 1fr !important;
  }
  .rf-page__filter-actions {
    justify-content: flex-start;
  }
}

.cc-page__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cc-page__table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 6px;
}

.cc-page__filter-card {
  margin-bottom: 14px;
}

.cc-page__filter-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 12px;
  padding: 8px 20px 18px;
  align-items: end;
}

.cc-page__filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cc-page__table-title {
  font-size: 15px;
  font-weight: 700;
  color: #182433;
}

.cc-page__table-subtitle {
  font-size: 12px;
  color: #656d77;
  margin-top: 4px;
}

.cc-page__identity {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cc-page__identity-name {
  font-weight: 700;
  color: #182433;
}

.cc-page__identity-sub {
  font-size: 12px;
  color: #656d77;
}

.cc-page__action-trigger {
  min-width: 108px;
  justify-content: center;
}

.cc-page__pks-cell {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
}

.cc-page__pks-pill {
  width: fit-content;
}

.cc-page__action-menu {
  padding: 8px;
}

.cc-page__action-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 190px;
  color: #1f2937;
}

.cc-page__action-item--danger {
  color: #c0392b;
}

.cc-page__action-icon {
  width: 18px;
  text-align: center;
}

.company-client-modal {
  padding: 6px 2px 2px;
}

.company-client-modal__intro {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(32, 107, 196, 0.08);
  color: #304152;
  font-size: 13px;
}

.company-client-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.company-client-modal__field-full {
  grid-column: 1 / -1;
}

.company-client-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

@media (max-width: 900px) {
  .cc-page__filter-grid {
    grid-template-columns: 1fr;
  }

  .cc-page__filter-actions {
    justify-content: flex-start;
  }

  .company-client-modal__grid {
    grid-template-columns: 1fr;
  }
}
</style>
